<script lang="ts" setup>
import { PropType } from 'vue';

const props = defineProps({
    isDark: {
        type: Boolean,
        default: false,
    },
    /**
     * 图标大小
     * ```ts
     * small: '48px'
     * medium: '64px'
     * large: '100px'
     * ```
     */
    size: {
        type: String as PropType<'small' | 'medium' | 'large'>,
        default: 'medium',
    },
    text: {
        type: String,
        default: '',
    },
});

const classes = computed(() => {
    const map = {
        small: 'w-48px h-48px',
        medium: 'w-64px h-64px',
        large: 'w-100px h-100px',
    };

    return map[props.size];
});
</script>

<template>
    <div
        class="grid place-content-center place-items-center text-xs-r"
        :class="[isDark ? 'c-[--gray-300]' : 'c-[--gray]']"
    >
        <slot v-if="$slots.default" />
        <img
            v-else-if="isDark"
            src="@img/base/empty-dark.svg"
            alt="empty"
            loading="lazy"
            :class="classes"
        >
        <img
            v-else
            src="@img/base/empty.svg"
            alt="empty"
            loading="lazy"
            :class="classes"
        >

        <p class="mt-10px text-center">
            {{ props.text || $t('暂无数据') }}
        </p>
    </div>
</template>
